import { render, staticRenderFns } from "./VaultFolderSelect.vue?vue&type=template&id=96094334"
import script from "./VaultFolderSelect.vue?vue&type=script&lang=js"
export * from "./VaultFolderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports